import React from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { DELETE_SCOPE } from "@/config/deleteScope";

export function DeleteDogConfirmation({ dogName, dogId, selectedDayKey, onDelete, isOpen, onOpenChange, triggerButton }) {
  const handleConfirm = async () => {
    // LOG [DEL_UI]: Click en botón de confirmación
    console.error("[DEL_UI] CONFIRM_BUTTON_CLICK", JSON.stringify({
      dogName,
      dogId,
      selectedDayKey,
      scope: DELETE_SCOPE.ALL,
      hasOnDelete: typeof onDelete === "function",
      timestamp: new Date().toISOString()
    }));
    
    try {
      // Ejecutar onDelete siempre con DELETE_SCOPE.ALL
      // Fase 2: pasar dogId (identidad estable) como último argumento opcional
      await onDelete?.(dogName, DELETE_SCOPE.ALL, selectedDayKey, dogId);

      
      console.error("[DEL_UI] ONDELETE_RESOLVED", JSON.stringify({
        dogName,
        scope: DELETE_SCOPE.ALL,
        selectedDayKey,
        timestamp: new Date().toISOString()
      }));
      
      // Cerrar DESPUÉS de que onDelete se haya ejecutado
      onOpenChange(false);
    } catch (err) {
      console.error("[DEL_UI] ONDELETE_THROW", JSON.stringify({
        dogName,
        scope: DELETE_SCOPE.ALL,
        selectedDayKey,
        error: err?.message || String(err),
        timestamp: new Date().toISOString()
      }));
      
      // No cerrar el dialog en caso de error para que el usuario pueda reintentar
    }
  };

  const handleCancel = () => {
    onOpenChange(false);
  };

  return (
    <AlertDialog open={isOpen} onOpenChange={(open) => {
      if (!open) handleCancel();
      else onOpenChange(true);
    }}>
      <AlertDialogTrigger asChild onClick={(e) => e.stopPropagation()}>
        {triggerButton}
      </AlertDialogTrigger>
      <AlertDialogContent onClick={(e) => e.stopPropagation()}>
        <AlertDialogHeader>
          <AlertDialogTitle>Eliminar cliente</AlertDialogTitle>
          <AlertDialogDescription>
            ¿Estás seguro de que quieres borrar a{" "}
            <span className="font-semibold">{dogName}</span>{" "}
            de la app?
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={handleCancel}>
            Cancelar
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={handleConfirm}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            Sí, borrar
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
